import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "PrintAll"
})

export class PrintAllPipe implements PipeTransform {
  transform(items: string[], separator: string = " "): string {
    if (!items) {
      return "";
    }

    return items.join(separator);
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/printAll.pipe.ts